var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Las comidas","audio2":"../mp3/PrimariaE/02PE.mp3","cover":"../img/5.jpg","name":"Primaria E - Lección #2"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }